<template>
  <v-layout wrap>
    <v-flex
      v-for="i in 20"
      :key="i"
      xs12="!isHideMap()"
      :xl6="!isHideMap()"
      :sm6="isHideMap()"
      :md4="isHideMap()"
      :lg3="isHideMap()"
      class="px-2"
    >
      <search-card-loader />
    </v-flex>
  </v-layout>
</template>

<script>
import SearchCardLoader from './SearchCardLoader.vue'
import { mapState } from 'vuex'

export default {
  components: { SearchCardLoader },

  props: {
    searchResult: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    ...mapState('agent', ['hideMap'])
  },

  methods: {
    isHideMap() {
      return this.hideMap || !this.searchResult
    }
  }
}
</script>
